import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Download16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.9697 6.46967L8.75 9.68939L8.75 1H7.25L7.25 9.68928L4.03039 6.46967L2.96973 7.53033L8.00006 12.5607L13.0304 7.53033L11.9697 6.46967Z'
      fill='currentColor'
    />
    <path
      d='M13.5 13.75L2.5 13.75V15.25L13.5 15.25V13.75Z'
      fill='currentColor'
    />
  </Svg>
);

Download16.displayName = 'Download16';
export default Download16;
